import { auth } from '../../src/firebase.js';
import { saveUserPreferences } from '../../src/auth.js';

export class Onboarding {
    constructor(containerId) {
        this.containerId = containerId;
        this.debounceTimer = null;
        this.selectedDay = 1;
        this.selectedMonth = 1;
        this.selectedYear = 2000;
    }

    init() {
        const container = document.getElementById(this.containerId);
        if (!container) return;

        this.injectStyles();

        const years = [];
        for (let i = 2026; i >= 1930; i--) years.push(i);
        const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        const days = Array.from({length: 31}, (_, i) => i + 1);

        container.innerHTML = `
            <div style="max-width: 600px; margin: 40px auto; padding: 30px; background: #fff; border-radius: 12px; box-shadow: 0 2px 10px rgba(0,0,0,0.05);">
                <h2 style="margin-bottom: 10px;">Welcome to FootballGirl! 👋</h2>
                <p style="color: #666; margin-bottom: 30px;">Let's get to know you better.</p>

                <form id="onboarding-form">
                    <div style="margin-bottom: 25px;">
                        <label class="fg-onb-label">Full Name</label>
                        <input type="text" id="onb-name" placeholder="Your Name" required style="width: 100%; padding: 12px; border: 1px solid #ddd; border-radius: 8px; font-size: 16px;">
                    </div>

                    <div style="margin-bottom: 25px;">
                        <label class="fg-onb-label">Date of Birth</label>
                        <div class="fg-wheel-picker-container">
                            <div class="fg-wheel-picker" id="wheel-day">
                                <div class="fg-wheel-spacer"></div>
                                ${days.map(d => `<div class="fg-wheel-item" data-val="${d}">${d}</div>`).join('')}
                                <div class="fg-wheel-spacer"></div>
                            </div>
                            <div class="fg-wheel-picker" id="wheel-month">
                                <div class="fg-wheel-spacer"></div>
                                ${months.map((m, i) => `<div class="fg-wheel-item" data-val="${i+1}">${m.substring(0,3)}</div>`).join('')}
                                <div class="fg-wheel-spacer"></div>
                            </div>
                            <div class="fg-wheel-picker" id="wheel-year">
                                <div class="fg-wheel-spacer"></div>
                                ${years.map(y => `<div class="fg-wheel-item" data-val="${y}">${y}</div>`).join('')}
                                <div class="fg-wheel-spacer"></div>
                            </div>
                            <div class="fg-wheel-highlight"></div>
                        </div>
                    </div>

                    <div style="margin-bottom: 30px; position: relative;">
                        <label class="fg-onb-label">Location</label>
                        <input type="text" id="onb-location" placeholder="Search city or country..." autocomplete="off" required style="width: 100%; padding: 12px; border: 1px solid #ddd; border-radius: 8px; font-size: 16px;">
                        <div id="location-suggestions" class="fg-location-suggestions"></div>
                    </div>

                    <button type="submit" class="fg-btn fg-btn--primary" style="width: 100%; justify-content: center; padding: 12px;">Complete Profile</button>
                </form>
            </div>
        `;

        this.attachEvents(container);
    }

    injectStyles() {
        const styleId = 'onboarding-custom-styles';
        if (document.getElementById(styleId)) return;
        const css = `
            .fg-onb-label { display: block; font-weight: 700; margin-bottom: 12px; color: #1a1a1a; font-size: 14px; text-transform: uppercase; letter-spacing: 0.5px; }
            
            /* Wheel Picker Styles */
            .fg-wheel-picker-container {
                display: flex;
                position: relative;
                height: 150px;
                background: #f8f9fa;
                border-radius: 12px;
                overflow: hidden;
                border: 1px solid #eee;
            }
            .fg-wheel-picker {
                flex: 1;
                overflow-y: scroll;
                scroll-snap-type: y mandatory;
                scrollbar-width: none;
                -ms-overflow-style: none;
                text-align: center;
                z-index: 2;
            }
            .fg-wheel-picker::-webkit-scrollbar { display: none; }
            .fg-wheel-item {
                height: 50px;
                line-height: 50px;
                font-size: 18px;
                font-weight: 600;
                color: #999;
                scroll-snap-align: center;
                transition: color 0.2s, font-size 0.2s;
            }
            .fg-wheel-spacer { height: 50px; }
            .fg-wheel-highlight {
                position: absolute;
                top: 50px;
                left: 10px;
                right: 10px;
                height: 50px;
                background: rgba(24, 119, 242, 0.05);
                border-top: 1px solid rgba(24, 119, 242, 0.2);
                border-bottom: 1px solid rgba(24, 119, 242, 0.2);
                pointer-events: none;
                z-index: 1;
                border-radius: 4px;
            }
            .fg-wheel-item.is-selected {
                color: var(--primary-blue);
                font-size: 22px;
            }

            .fg-location-suggestions {
                position: absolute;
                top: 100%;
                left: 0;
                right: 0;
                background: white;
                border: 1px solid #ddd;
                border-top: none;
                border-radius: 0 0 8px 8px;
                max-height: 200px;
                overflow-y: auto;
                z-index: 1000;
                display: none;
                box-shadow: 0 4px 12px rgba(0,0,0,0.1);
            }
            .fg-location-item {
                padding: 12px;
                cursor: pointer;
                transition: background 0.2s;
                font-size: 14px;
            }
            .fg-location-item:hover {
                background: #f5f6f8;
            }
        `;
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = css;
        document.head.appendChild(style);
    }

    attachEvents(container) {
        const locationInput = container.querySelector('#onb-location');
        const suggestionsBox = container.querySelector('#location-suggestions');

        // 1. Internet-Hooked Location Search (Nominatim API)
        locationInput.addEventListener('input', (e) => {
            clearTimeout(this.debounceTimer);
            const query = e.target.value.trim();
            
            if (query.length < 3) {
                suggestionsBox.style.display = 'none';
                return;
            }

            this.debounceTimer = setTimeout(async () => {
                try {
                    const resp = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&addressdetails=1&limit=5`);
                    const data = await resp.json();
                    
                    if (data && data.length > 0) {
                        suggestionsBox.innerHTML = data.map(item => {
                            const name = item.display_name;
                            return `<div class="fg-location-item" data-full="${name}">${name}</div>`;
                        }).join('');
                        suggestionsBox.style.display = 'block';
                    } else {
                        suggestionsBox.style.display = 'none';
                    }
                } catch (err) {
                    console.error("Location search failed", err);
                }
            }, 400);
        });

        // 2. Wheel Picker Logic
        const setupWheel = (id, callback) => {
            const wheel = container.querySelector(`#${id}`);
            wheel.addEventListener('scroll', () => {
                const index = Math.round(wheel.scrollTop / 50);
                const items = wheel.querySelectorAll('.fg-wheel-item');
                items.forEach((item, i) => {
                    item.classList.toggle('is-selected', i === index);
                });
                if (items[index]) {
                    callback(items[index].dataset.val);
                }
            });
            // Initialize default position (Year 2000, etc.)
            if (id === 'wheel-year') wheel.scrollTop = (2026 - 2000) * 50;
        };

        setupWheel('wheel-day', val => this.selectedDay = val);
        setupWheel('wheel-month', val => this.selectedMonth = val);
        setupWheel('wheel-year', val => this.selectedYear = val);

        suggestionsBox.addEventListener('click', (e) => {
            const item = e.target.closest('.fg-location-item');
        });

        suggestionsBox.addEventListener('click', (e) => {
            const item = e.target.closest('.fg-location-item');
            if (item) {
                locationInput.value = item.textContent;
                suggestionsBox.style.display = 'none';
            }
        });

        document.addEventListener('click', (e) => {
            if (!locationInput.contains(e.target) && !suggestionsBox.contains(e.target)) {
                suggestionsBox.style.display = 'none';
            }
        });

        container.querySelector('#onboarding-form').addEventListener('submit', async (e) => {
            e.preventDefault();
            const user = auth.currentUser;

            if (!user) {
                alert("You must be signed in to save preferences.");
                if (window.app) window.app.handleNavigation('login');
                return;
            }

            // 1. Collect data from the form
            const preferences = {
                displayName: container.querySelector('#onb-name').value,
                dob: `${this.selectedYear}-${String(this.selectedMonth).padStart(2, '0')}-${String(this.selectedDay).padStart(2, '0')}`,
                location: container.querySelector('#onb-location').value,
                onboardingComplete: true // Flag to prevent showing this again
            };

            try {
                // 2. Save data to Firestore
                await saveUserPreferences(user.uid, preferences);
                console.log('Preferences saved for user:', user.uid);

                // 3. Redirect to Profile
                if (window.app) window.app.handleNavigation('profile');
            } catch (error) {
                alert("There was an error saving your preferences. Please try again.");
            }
        });
    }
}